/**
 * The player's side of the welcome shell (public/welcome-shell.js, Tom
 * 2026-10-12 "SSi welcome design"). The shell streams the course welcome on a
 * first-ever visit before this bundle has loaded; these two calls are the whole
 * contract with it. Both are no-ops when the shell did nothing.
 */
interface ShellWelcome { claimed: boolean; playing: boolean; stop: () => void }

function shell(): ShellWelcome | null {
  if (typeof window === 'undefined') return null
  return ((window as unknown as { __ssiShellWelcome?: ShellWelcome }).__ssiShellWelcome) ?? null
}

/** True once the shell has started the welcome on this page load. */
export function shellWelcomeClaimed(): boolean {
  return !!shell()?.claimed
}

/** The lesson always wins: stop the shell's welcome the moment play is pressed. */
export function stopShellWelcome(): void {
  try { shell()?.stop() } catch { /* the shell never breaks the player */ }
}
